<template>
  <div>
    <div class="loading-bg" v-if="loading">
      <div class="loading">
        <h2>{{ loadingText }}</h2>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useOverViewStore } from '@/store';
import { storeToRefs } from 'pinia';
const store = useOverViewStore();
const { ueStatus } = storeToRefs(store);

const loading = ref(true);
let loadingText = ref('三维场景加载中');
const ue = window.ue;
const ue4 = window.ue4;

// dbBrowser加载网页完成
const loadDbBrowser = () => {
  let timer = setInterval(() => {
    if (ue && ue.interface && ue4) {
      console.log('DbBrowser加载网页完成');
      clearInterval(timer);
      loading.value = false;
      ueStatus.value = true;
    }
  }, 100);
};

onMounted(() => {
  loadDbBrowser();
});
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
